import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as promotionActions from './../../../../actions/promotionAction';
import AutoFill from './AutoFill';

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAutoFill: (filters) => dispatch(promotionActions.getListAutoFill(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AutoFill));
